

export abstract class GoToPaso3ServiceVM {

    abstract goToPaso3(): Promise<any>;
}
